import { motion } from "motion/react";

function ACGraph({ activeStep, stepId }: { activeStep: number; stepId: number }) {
  return (
    <>
      <motion.path
        d="M12 269C12 269 48 210 66 92C102 329 138 314 173 137C209 314 241 305 282 164C292 187 319 249 337 269"
        stroke="url(#paint_ac)"
        strokeWidth="24"
        strokeLinecap="round"
        strokeLinejoin="round"
        initial="hidden"
        variants={{
          show: {
            pathLength: [0.001, 1],
            pathOffset: [0.0001],
            opacity: 1,
            transition: { duration: 2, ease: [0.25, 0.1, 0.25, 1] },
          },
          hidden: {
            pathLength: [1, 0.001],
            pathOffset: [0.0001, 0.9999],
            opacity: 0,
            transition: { pathLength: { opacity: 0.2 } },
          },
        }}
        animate={activeStep === stepId ? "show" : "hidden"}
      />
      <defs>
        <linearGradient
          id="paint_ac"
          x1="175"
          y1="92"
          x2="175"
          y2="270"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF8400" />
          <stop offset="1" stopColor="#FFCEA1" />
        </linearGradient>
      </defs>
    </>
  );
}

export default ACGraph;
